var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';
import { inject, observer } from 'mobx-react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import DeliveryAddressCheckoutForm from '../../pages/SettingsPage/forms/DeliveryAddressCheckoutForm';
import { GENDERS, TITLES } from '../../../framework/constants/profile';
import styles from './DeliveryAddressesModal.styl';
let DeliveryAddressesModal = class DeliveryAddressesModal extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "updatePhoneInForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const { profileStore } = this.props;
                const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const getCurrentDeliveryAddress = !!getDeliveryAddreses && getDeliveryAddreses.find((item) => item.id === id);
                const deliveryPhone = _get(getCurrentDeliveryAddress, 'phoneMain', false);
                DeliveryAddressCheckoutForm.$('deliveryAddress.phoneMain').set('rules', {
                    countryCode: deliveryPhone ? '' : 'required',
                    areaCode: deliveryPhone ? '' : 'required|phone_areaCode',
                    phoneNumber: deliveryPhone ? 'required|phone' : 'required|phone_phoneNumber'
                });
                if (!!deliveryPhone) {
                    DeliveryAddressCheckoutForm.$('deliveryAddress.phoneMain').set('value', {
                        countryCode: '',
                        areaCode: '',
                        phoneNumber: deliveryPhone
                    });
                }
            }
        });
        Object.defineProperty(this, "checkShouldUpdatePhoneInForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, id) => {
                const { profileStore } = this.props;
                const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const getCurrentDeliveryAddress = !!getDeliveryAddreses && getDeliveryAddreses.find((item) => item.id === id);
                const deliveryPhone = _get(getCurrentDeliveryAddress, 'phoneMain', false);
                const deliveryPhoneInForm = form.$('deliveryAddress.phoneMain').value.phoneNumber;
                if (deliveryPhone !== deliveryPhoneInForm) {
                    this.updatePhoneInForm(); // check if filled phoneNumber in 3 fields, and then switch to 1 field
                }
            }
        });
        Object.defineProperty(this, "onAddressesSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const { notificationStore, profileStore, t } = this.props;
                DeliveryAddressCheckoutForm.submit()
                    .then((form) => {
                    const values = form.values();
                    const getCurrentAddressData = _get(values, 'deliveryAddress', null);
                    this.setState({ isPageLoaded: true });
                    return profileStore.updateUserProfileData({ deliveryAddress: getCurrentAddressData })
                        .then(() => profileStore.getProfileData())
                        .then(() => {
                        this.checkShouldUpdatePhoneInForm(form, id);
                        this.setState({ isPageLoaded: false });
                    })
                        .catch((error) => {
                        const { errors } = error;
                        console.log('errors', error);
                        // TODO: Install jsonapi de-serialaizer and use it everywhere in app.
                        // TODO: Move this part of code somewhere to the upper level of the abstraction
                        if (errors) {
                            errors.forEach((error) => {
                                if (error.status === '500') {
                                    notificationStore.addNotification({
                                        message: t('Notifications:errors.serverError'),
                                        level: 'error'
                                    });
                                    return;
                                }
                                const pointer = error.source && error.source.pointer;
                                const invalidationText = error.detail;
                                if (!pointer)
                                    return;
                                const fieldName = pointer.split('/')[(pointer.split('/').length - 1)];
                                if (pointer.indexOf('deliveryAddress') >= 0) {
                                    notificationStore.addNotification({
                                        message: `Delivery Address ${fieldName} - ${invalidationText}`
                                    });
                                    form.$(`deliveryAddress.${fieldName}`).invalidate(invalidationText);
                                }
                            });
                            return;
                        }
                        // TODO: handle jsonapi validation errors
                        // when CORS issues fixed.
                        // TODO: install some jsonapi client library
                        notificationStore.addNotification({
                            message: t('Notifications:errors.validationError')
                        });
                    });
                })
                    .catch((err) => {
                    const { errors } = err;
                    // err is either an Error instance or an array with errors from BE
                    const formattedError = _get(errors, '[0].detail', err);
                    notificationStore.addNotification({
                        message: formattedError,
                        level: 'error'
                    });
                });
            }
        });
        Object.defineProperty(this, "onAddressesModalSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const { appStore } = this.props;
                DeliveryAddressCheckoutForm.validate({ showErrors: true })
                    .then((form) => {
                    if (form.isValid) {
                        this.onAddressesSave(id);
                        appStore.hideModal('DELIVERY_ADDRESSES_ADD_MODAL');
                    }
                    else {
                        console.log('Form errors 3', form.errors());
                    }
                });
            }
        });
        Object.defineProperty(this, "setValuesToFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const { profileStore } = this.props;
                const value = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const item = value.find((item) => item.id === id);
                const values = DeliveryAddressCheckoutForm.values();
                Object.keys(values).forEach((parentFieldName) => {
                    Object.keys(values[parentFieldName]).forEach((key) => {
                        let value = item[key];
                        if (key === 'gender') {
                            value = GENDERS[value];
                        }
                        // Special cases for dropdown title value
                        if (key === 'title') {
                            value = TITLES[value];
                        }
                        if (key === 'country') {
                            value = value ? { value: value.id, label: value.name } : null;
                        }
                        if (key === 'phoneMain' && !!value) {
                            DeliveryAddressCheckoutForm.$(`deliveryAddress.phoneMain.phoneNumber`).set(value);
                            return;
                        }
                        DeliveryAddressCheckoutForm.$(`deliveryAddress.${key}`).set(value);
                        DeliveryAddressCheckoutForm.$(`deliveryAddress.${key}`).validate();
                    });
                });
                this.updatePhoneInForm(id);
            }
        });
        Object.defineProperty(this, "handleDeliverySelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (selectedValue) => {
                const { appStore, profileStore: { setDeliveryAddressesProfile, setDeliveryCheckoutAddressObj } } = this.props;
                const setCurrentDeliveryAddress = `${selectedValue.firstName} ${selectedValue.lastName} ${selectedValue.street} ${selectedValue.number}, ${selectedValue.zip} ${selectedValue.city}`;
                const setCurrentDeliveryAddressObj = {
                    firstName: selectedValue.firstName,
                    lastName: selectedValue.lastName,
                    city: selectedValue.city,
                    number: selectedValue.number,
                    street: selectedValue.street,
                    zip: selectedValue.zip
                };
                setDeliveryAddressesProfile(setCurrentDeliveryAddress);
                setDeliveryCheckoutAddressObj(setCurrentDeliveryAddressObj);
                appStore.hideModal('DELIVERY_ADDRESSES_MODAL');
            }
        });
        Object.defineProperty(this, "resetValidation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form) => {
                return form.each((field) => {
                    form.state.options.set({ validateOnChange: false });
                    field.clear();
                    field.resetValidation(true);
                    form.$(`deliveryAddress.phoneMain.countryCode`).set('value', '+49');
                    form.state.options.set({ validateOnChange: true });
                });
            }
        });
        Object.defineProperty(this, "onContactsEdit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => {
                const { t, appStore, profileStore } = this.props;
                const getDeliveryAddreses = _get(profileStore, 'userProfile.deliveryAddresses', null);
                const getCurrentDeliveryAddress = !!getDeliveryAddreses && getDeliveryAddreses.find((item) => item.id === id);
                const deliveryPhone = _get(getCurrentDeliveryAddress, 'phoneMain', false);
                const hasPhone = !!deliveryPhone;
                const modalProps = {
                    t,
                    hasPhone,
                    form: DeliveryAddressCheckoutForm,
                    onConfirm: () => this.onAddressesModalSave(id),
                    onDecline: () => {
                        this.resetValidation(DeliveryAddressCheckoutForm);
                        appStore.hideModal('DELIVERY_ADDRESSES_ADD_MODAL');
                    }
                };
                this.resetValidation(DeliveryAddressCheckoutForm);
                if (id) {
                    this.setValuesToFields(id);
                }
                appStore.showModal('DELIVERY_ADDRESSES_ADD_MODAL', modalProps);
            }
        });
        Object.defineProperty(this, "renderAddressValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                const { t } = this.props;
                if (!!value) {
                    return React.createElement("span", { className: styles.privateAddressValue }, value);
                }
                else {
                    return React.createElement("span", { className: styles.privateAddressRequired }, t('dashboard.required'));
                }
            }
        });
        Object.defineProperty(this, "renderAddressData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                const { t, profileStore: { setDeliveryCheckoutAddressObj } } = this.props;
                if (!!data) {
                    const getAddressData = _pick(data, ['id', 'firstName', 'lastName', 'street', 'number', 'zip', 'city', 'phoneMain']);
                    const onCheckOnEmptyValue = _pick(data, ['firstName', 'lastName', 'street', 'number', 'zip', 'city', 'phoneMain']);
                    const isEmptyValue = Object.values(onCheckOnEmptyValue).some(_isEmpty);
                    const fullName = `${getAddressData.firstName} ${getAddressData.lastName}`;
                    const setCurrentDeliveryAddress = `${getAddressData.firstName} ${getAddressData.lastName} ${getAddressData.street} ${getAddressData.number}, ${getAddressData.zip} ${getAddressData.city}`;
                    const setCurrentDeliveryAddressObj = { city: getAddressData.city, number: getAddressData.number, street: getAddressData.street, zip: getAddressData.zip };
                    return (React.createElement("div", { className: styles.editPrivateAddress, key: getAddressData.id },
                        React.createElement("h3", { className: styles.editPrivateAddressTitle }, t(`dashboard.deliveryAddress`)),
                        React.createElement("div", { className: styles.privateAddressContent },
                            React.createElement("div", null,
                                React.createElement("span", { className: styles.privateAddressLabel },
                                    t('forms.contactForm.name'),
                                    ":\u00A0"),
                                this.renderAddressValue(fullName)),
                            React.createElement("div", null,
                                React.createElement("span", { className: styles.privateAddressLabel },
                                    t('forms.contactForm.address'),
                                    ":\u00A0"),
                                this.renderAddressValue(`${getAddressData.street} ${getAddressData.number}`)),
                            React.createElement("div", null,
                                React.createElement("span", { className: styles.privateAddressLabel },
                                    t('forms.contactForm.placeholders.city'),
                                    ":\u00A0"),
                                this.renderAddressValue(`${getAddressData.zip} ${getAddressData.city}`)),
                            React.createElement("div", null,
                                React.createElement("span", { className: styles.privateAddressLabel },
                                    t('forms.contactForm.phoneNumber'),
                                    ":\u00A0"),
                                this.renderAddressValue(getAddressData.phoneMain))),
                        React.createElement("div", { className: styles.wrapBtn },
                            isEmptyValue ? (React.createElement(Button, { className: styles.buttonAddressComplete, variant: 'outlined', style: { color: 'var(--md-error)', borderColor: 'var(--md-error)' }, onClick: () => this.onContactsEdit(getAddressData.id) }, t('dashboard.completeAddress'))) : (React.createElement(Button, { className: styles.buttonAddress, variant: 'outlined', onClick: () => this.onContactsEdit(getAddressData.id) }, t('dashboard.editAddress'))),
                            React.createElement(Button, { className: styles.buttonSelect, variant: 'filled', onClick: () => this.handleDeliverySelect(getAddressData) }, t('dashboard.select')))));
                }
                else {
                    return (React.createElement("button", { className: styles.addDeliveryAddress, onClick: () => this.onContactsEdit() },
                        React.createElement("span", { className: styles.addDeliveryAddressIcon }, "+"),
                        React.createElement("span", { className: styles.addDeliveryAddressTitle }, t('dashboard.titleAddDeliveryAddress'))));
                }
            }
        });
        this.state = {
            isPageLoaded: true
        };
    }
    componentDidMount() {
        this.updatePhoneInForm();
        this.setState({ isPageLoaded: false });
    }
    render() {
        const { t, profileStore } = this.props;
        const isDeliveryAddress = _get(profileStore, 'userProfile.deliveryAddresses', null);
        const isDisableAdd = !!isDeliveryAddress && isDeliveryAddress.length === 2;
        const isDisableAddNew = !!isDeliveryAddress && isDeliveryAddress.length >= 1;
        return (React.createElement("div", { className: styles.wrapper },
            !!isDeliveryAddress ? isDeliveryAddress.map((item) => this.renderAddressData(item)) : null,
            React.createElement("button", { className: classnames(styles.addDeliveryAddress, { [styles.addDeliveryAddressDisable]: isDisableAdd }), onClick: () => this.onContactsEdit() },
                React.createElement("span", { className: styles.addDeliveryAddressIcon }, "+"),
                React.createElement("span", { className: styles.addDeliveryAddressTitle }, t('dashboard.titleAddDeliveryAddress'))),
            React.createElement("button", { className: classnames(styles.addDeliveryAddress, styles.addDeliveryAddressNew, { [styles.addDeliveryAddressDisable]: isDisableAddNew }), onClick: () => this.onContactsEdit() },
                React.createElement("span", { className: styles.addDeliveryAddressIcon }, "+"),
                React.createElement("span", { className: styles.addDeliveryAddressTitle }, t('dashboard.titleAddDeliveryAddressNew')))));
    }
};
DeliveryAddressesModal = __decorate([
    inject('appStore', 'profileStore', 'notificationStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], DeliveryAddressesModal);
export default DeliveryAddressesModal;
